import { Edge, MarkerType } from "@xyflow/react";

interface CreateStyledEdgeParams {
	sourceId: string;
	targetId: string;
	label?: string;
	index?: number;
}

export function createStyledEdge({
	sourceId,
	targetId,
	label = "",
	index = 0,
}: CreateStyledEdgeParams): Edge {
	return {
		id: `e-${sourceId}-${targetId}-${index}`, // eindeutige Edge-ID
		source: sourceId,
		target: targetId,
		label,
		animated: false,
		markerEnd: {
			type: MarkerType.ArrowClosed,
			color: "#686761",
		},
		style: {
			stroke: "#686761", // Kantenfarbe
			strokeWidth: 1.5,
			border: "1px solid #686761",
		},
		labelStyle: {
			fontSize: 12,
			fontWeight: 500,
		},
		labelBgStyle: {
			backgroundColor: "#fff",
			fillOpacity: 1,
		},
		labelBgPadding: [6, 4],
		labelBgBorderRadius: 5,
	};
}
